export enum ShopType {
  DIGIMAP = 'DIGIMAP',
  DIGIMAP_FOR_SCHOOLS = 'DIGIMAP_FOR_SCHOOLS',
  DIGIMAP_FOR_SCHOOLS_OFSTED = 'DIGIMAP_FOR_SCHOOLS_OFSTED',
}
